<!--万达电影app-首页-->
<template>
  <div class="home">
    <img src="./img4.png" alt="">
    <div class="clickBlock area1" @click="area1Fun"></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',
  components: {
    // HelloWorld,
  },
  methods:{
    area1Fun(){
      this.$router.push('Home')
    }
  }
};
</script>
<style lang="less" scoped>
  .home {
    width: 100vw;
    height: 100vh;
    position: relative;
    >img {
      position: relative;
      width: 100%;
      height: 100%;
      display: block;
      margin: 0;
      padding: 0;
    }
    .area1 {
      width: 15vw;
      height: 15vw;
      top: 93vh;
      left: 80vw;
    }
  }
</style>
